module.exports = __webpack_public_path__ + "static/media/loginPage.f59ebdf8.png";